export class AbortSignalManager {
    abortController: AbortController;
    timeout: number | undefined;
    timeoutId: ReturnType<typeof setTimeout>;

    constructor(timeout?: number) {
        this.timeout = timeout;
        this.createAbortSignal();
    }

    createAbortSignal() {
        this.abortController = new AbortController();
        if (this.timeout) {
            this.timeoutId = setTimeout(() => {
                this.abortController.abort();
            }, this.timeout);
        }
        return this.abortController.signal;
    }

    abort() {
        if (this.abortController) {
            this.abortController.abort();
        }

        if (this.timeoutId) {
            clearTimeout(this.timeoutId);
        }
    }

    isAborted() {
        return this.abortController.signal.aborted;
    }
}
